module.exports = __webpack_public_path__ + "img/skin-care-goal-slide1.4b794106.png";